import { render, staticRenderFns } from "./WeightRecording1.vue?vue&type=template&id=17521dd4&scoped=true&"
import script from "./WeightRecording1.vue?vue&type=script&lang=js&"
export * from "./WeightRecording1.vue?vue&type=script&lang=js&"
import style0 from "./WeightRecording1.vue?vue&type=style&index=0&id=17521dd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17521dd4",
  null
  
)

export default component.exports